import IndirizzoEntity from '../generale/IndirizzoEntity';
import AssociazioneEntity from '../associazioni/AssociazioneEntity';
import UtenteEntity from './UtenteEntity';

export default function (associato) {
  this.id = associato ? associato.id : null;
  this.Anno = associato ? associato.Anno : null;
  this.Denominazione = associato ? associato.Denominazione : null;
  this.isAttivo = associato ? associato.isAttivo : true;
  this.Tipo = associato ? associato.Tipo : 'I';
  this.Telefono = associato ? associato.Telefono : null;
  this.Cellulare = associato ? associato.Cellulare : null;
  this.Email = associato ? associato.Email : null;
  this.EmailPec = associato ? associato.EmailPec : null;
  this.SitoWeb = associato ? associato.SitoWeb : null;
  this.IndirizzoCorrispondenza = associato ? new IndirizzoEntity(associato.IndirizzoCorrispondenza) : new IndirizzoEntity();
  this.IndirizzoDomicilio = associato ? (associato.IndirizzoDomicilio ? new IndirizzoEntity(associato.IndirizzoDomicilio) : null) : null;
  this.IndirizzoCampo = associato ? (associato.IndirizzoCampo ? new IndirizzoEntity(associato.IndirizzoCampo) : null) : null;
  this.isTrattamentoDatiPersonali = associato ? associato.isTrattamentoDatiPersonali : false;
  this.Open = associato ? associato.Open : true;
  this.DataTrattamentoDatiPersonali = associato ? associato.DataTrattamentoDatiPersonali : null;
  this.createdAt = associato ? associato.createdAt : null;
  this.updatedAt = associato ? associato.updatedAt : null;
  this.Note = associato ? associato.Note : null;
  this.NumeroTessera = associato ? associato.NumeroTessera : null;
  this.Nome = associato ? associato.Nome : null;
  this.Cognome = associato ? associato.Cognome : null;
  this.CodiceFiscale = associato ? associato.CodiceFiscale : null;
  this.Sesso = associato ? associato.Sesso : null;
  this.NomeTutore = associato ? associato.NomeTutore : null;
  this.CognomeTutore = associato ? associato.CognomeTutore : null;
  this.CodiceFiscaleTutore = associato ? associato.CodiceFiscaleTutore : null;
  this.SessoTutore = associato ? associato.SessoTutore : null;
  this.DataNascita = associato ? associato.DataNascita : null;
  this.LocalitaNascita = associato ? associato.LocalitaNascita : null;
  this.CittaNascita = associato ? associato.CittaNascita : null;
  this.NazioneNascita = associato ? associato.NazioneNascita : 'IT';
  this.ProvinciaNascita = associato ? associato.ProvinciaNascita : null;
  this.Cittadinanza = associato ? associato.Cittadinanza : null;

  this.DataIscrizione = associato ? associato.DataIscrizione : null;
  this.TipoTessera = associato ? associato.TipoTessera : null;
  this.DataScadenzaCertificato = associato ? associato.DataScadenzaCertificato : null;
  this.Disabile = associato ? associato.Disabile : false;
  this.Agonista = associato ? associato.Agonista : false;
  this.RichiestoPassGare = associato ? associato.RichiestoPassGare : null;
  this.RichiestoRinnovo = associato ? associato.RichiestoRinnovo : null;
  this.TutelaSanitaria = associato ? associato.TutelaSanitaria : null;
  this.canViewData = associato ? associato.canViewData : false;
  this.Istruttore = associato ? associato.Istruttore : null;
  this.DataQualificaIstruttore = associato ? associato.DataQualificaIstruttore : null;
  this.AbilitazioneIstruttore = associato ? associato.AbilitazioneIstruttore : null;
  this.TipoTesseraIstruttore = associato ? associato.TipoTesseraIstruttore : null;
  this.TesseraCsain = associato ? associato.TesseraCsain : null;
  this.NumeroTesseraIstruttore = associato ? associato.NumeroTesseraIstruttore : null;

  this.Tecnico = associato ? associato.Tecnico : null;
  this.DataQualificaTecnico = associato ? associato.DataQualificaTecnico : null;
  this.AbilitazioneTecnico = associato ? associato.AbilitazioneTecnico : null;
  this.TipoTesseraTecnico = associato ? associato.TipoTesseraTecnico : null;
  this.NumeroTesseraTecnico = associato ? associato.NumeroTesseraTecnico : null;

  this.Quadro = associato ? associato.Quadro : null;
  this.RuoloQuadro = associato ? associato.RuoloQuadro : null;
  this.TipoTesseraQuadro = associato ? associato.TipoTesseraQuadro : null;

  this.Associazione = associato ? new AssociazioneEntity(associato.Associazione) : new AssociazioneEntity();
  this.DataIscrizione = associato ? associato.DataIscrizione : null;
  this.DataScadenza = associato ? associato.DataScadenza : null;
  this.DataSospensione = associato ? associato.DataSospensione : null;
  this.DataRadiazione = associato ? associato.DataRadiazione : null;
  this.DataTesseramento = associato ? associato.DataTesseramento : null;
  this.StatoIscrizione = associato ? associato.StatoIscrizione : 'Inserito';
  this.iscrizioneId = associato ? associato.iscrizioneId : null;
  this.Attestato = associato ? associato.Attestato : null;
  this.CodiceCorso = associato ? associato.CodiceCorso : null;
  this.DataInizioCorso = associato ? associato.DataInizioCorso : null;
  this.DataFineCorso = associato ? associato.DataFineCorso : null;
  this.LuogoCorso = associato ? associato.LuogoCorso : null;
  this.IstruttoreCorso = associato ? associato.IstruttoreCorso : null;
  this.istruttoreCorsoId = associato ? associato.istruttoreCorsoId : null;
  this.Utente = associato ? new UtenteEntity(associato.Utente) : null;
  this.isDatiCompleti = associato ? associato.isDatiCompleti : true;
}
